import { useAtom } from "jotai";
import { useRouter } from "next/router";
import { useCallback } from "react";

import { LOCAL_STORAGE_ACCESS_TOKEN_KEY, LOCAL_STORAGE_ACCESS_TOKEN_EXPIRES_AT_KEY } from "@/global-state/app-config";
import { authUserAtom, idTokenAtom, loadingAtom } from "@/global-state/jotai-atom";
import { loginPath } from "@/global-state/store-app-path";

export const useResetAuth = () => {
  const router = useRouter();

  const [, setLoading] = useAtom(loadingAtom);
  const [, setAuthUser] = useAtom(authUserAtom);
  const [, setIdToken] = useAtom(idTokenAtom);

  const resetAuth = useCallback(async () => {
    setAuthUser(null);
    setIdToken(undefined);
    setLoading(false);
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN_EXPIRES_AT_KEY);
    await router.push(loginPath);
  }, [router]);

  return {
    resetAuth,
  };
};
